import styled from 'styled-components';

export const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

export const DropdownWrapper = styled.div`
  display: inline-block;
  max-width: 360px;
  padding-right: 20px;
`;

export const StyledTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const StyledMLTable = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const StyledMLTableTopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 25px;
`;
